import { CommentPayload } from "src/entity/comment/comment.entity";
import http from "../utils/http-common";

const baseCommentPath = "/api/comments";

export const getComment = (params: { companyId: string | null; path: string }) => {
  return http.get(`${baseCommentPath}`, { params });
};

export const createComment = (data: CommentPayload[]) => {
  return http.post(`${baseCommentPath}`, data);
};

export const updateComment = (data: CommentPayload) => {
  return http.patch(`${baseCommentPath}`, data);
};
